/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_box_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online box plot maker. Paste one column per group to draw box-and-whisker plots showing median, quartiles and range for each group.`)
};

const es_box_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador gratuito de diagramas de caja online. Pega una columna numérica por grupo para dibujar diagramas de caja y bigotes que muestran la mediana, los cuartiles y el rango de cada grupo.`)
};

const de_box_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Box-Plot-Ersteller. Fügen Sie eine numerische Spalte pro Gruppe ein, um Box-Whisker-Diagramme zu zeichnen, die Median, Quartile und Spannweite für jede Gruppe zeigen.`)
};

const nl_box_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online boxplotmaker. Plak één kolom per groep om box-and-whiskerplots te tekenen die de mediaan, kwartielen en spreiding van elke groep tonen.`)
};

const fr_box_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur gratuit de boîte à moustaches en ligne. Collez une colonne par groupe pour tracer des boîtes à moustaches montrant la médiane, les quartiles et l'étendue de chaque groupe.`)
};

const it_box_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore gratuito di box plot online. Incolla una colonna numerica per gruppo per disegnare box plot che mostrano mediana, quartili e intervallo per ciascun gruppo.`)
};

const pt_br2_box_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador gratuito online de boxplot. Cole uma coluna numérica por grupo para desenhar diagramas de caixa mostrando mediana, quartis e amplitude de cada grupo.`)
};

const pt_box_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador gratuito de diagramas de extremos e quartis online. Cole uma coluna numérica por grupo para desenhar diagramas de extremos e quartis que mostram a mediana, os quartis e a amplitude de cada grupo.`)
};

const ja_box_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンライン箱ひげ図作成ツール。グループごとに1列を貼り付けると、各グループの中央値、四分位範囲、範囲を示す箱ひげ図が描画されます。`)
};

const zh_box_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线箱线图制作工具。每组粘贴一列数据即可绘制箱须图，展示每组的中位数、四分位数和范围。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const box_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.box_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("box_meta_description", locale)
	if (locale === "en") return en_box_meta_description(inputs)
	if (locale === "es") return es_box_meta_description(inputs)
	if (locale === "de") return de_box_meta_description(inputs)
	if (locale === "nl") return nl_box_meta_description(inputs)
	if (locale === "fr") return fr_box_meta_description(inputs)
	if (locale === "it") return it_box_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_box_meta_description(inputs)
	if (locale === "pt") return pt_box_meta_description(inputs)
	if (locale === "ja") return ja_box_meta_description(inputs)
	return zh_box_meta_description(inputs)
};